import React from "react";

function NotFound() {
  return (
    <div className="container mx-auto max-w-7xl flex flex-col h-screen items-center justify-center">
      <h2 className="text-3xl font-bold">404 Not found</h2>
    </div>
  );
}

export default NotFound;
